module.exports = __webpack_public_path__ + "media/images/plans/wedding_compact/estimate_3-b4451697eaadf0308eff85c477040ffa.jpg";